import { Action } from '@ngrx/store';
import { IScannerSource } from '../../services/default-scanner.service';
import { IGetScansPayload } from '../interfaces';

export const ScannerActions = {
  APPLICATION_BATCH_ERROR: '[Scanner] Batch threw an Application Error',
  LOAD_SCANNER: '[Scanner] Loading Web TWAIN',
  SCANNER_LOADED: '[Scanner] Web TWAIN Loaded & Ready',
  INITIALIZE_SCANNER: '[Scanner] Initialize Begin',
  SCANNER_INITIALIZED: '[Scanner] Initialize Complete',
  GET_SCANNER_LIST: '[Scanner] Get Source List',
  SCANNER_LIST_RECEIVED: '[Scanner] Source List Received',
  SELECT_SCANNER: '[Scanner] Select Source',
  SCANNER_SELECTED: '[Scanner] Source Selected',
  FORM_STATUS_TOGGLE: '[Scanner] Form Status Toggle',
  ACQUIRE_IMAGES: '[Scanner] Acquire Begin',
  IMAGES_ACQUIRED: '[Scanner] Acquire Complete',
  EXTRACT_IMAGES: '[Scanner] Extract Begin',
  IMAGES_EXTRACTED: '[Scanner] Extract Complete',
  SCAN_FAILED: '[Scanner] Scanning Failed',
  NOTHING_TO_SCAN: '[Scanner] Nothing To Scan',
  SEND_IMAGES_BATCH: '[Scanner] Batch Send Begin',
  SEND_IMAGES_BATCH_ERROR: '[Scanner] Abort Batch Send, Error Sending Images Over Network',
  IMAGE_SENT: '[Scanner] Image Sent',
  IMAGES_BATCH_SENT: '[Scanner] Batch Send Complete',
  DESTROY_SCANNER: '[Scanner] Destroy Begin',
  SCANNER_DESTROYED: '[Scanner] Destroy Complete',
  UPDATE_SCAN_STATUS: '[Scanner] Update Scan Status',
  SCANS_ENTITIES_RECEIVED: '[Scanner] Scan Entities Received',
  UPDATE_SCAN_ERROR: '[Scanner] Update Scan Error',
  GET_SCANS: '[Scans] Fetch Scans',
  GET_SCANS_SUCCESS: '[Scans] Scans Data Received',
  GET_SCANS_ERROR: '[Scans] Scans Retrieval Error',
  API_POLICY_RECEIVED: '[Scanner] Api Policy Received',
  FETCH_API_POLICY: '[Scanner] Fetch Api Policy',
  FETCH_API_POLICY_ERROR: '[Scanner] Fetch Api Policy Error',
  SUBMIT_TO_SCORING: '[Scanner] Submit To Scoring',
  SUBMIT_TO_SCORING_ERROR: '[Scanner] Submit To Scoring Error',
  SUBMIT_TO_SCORING_COMPLETED: '[Scanner] Submit To Scoring Completed',
  SCORING_COMPLETED: '[Scanner] Scoring Completed',
  RESET_SCANS: '[Scanner] Reset Scans',
  FETCH_API_STATUS: '[Scanner] Fetch API Status',
  FETCH_API_STATUS_SUCCESS: '[Scanner] Fetch API Status Success',
  FETCH_API_STATUS_ERROR: '[Scanner] Fetch API Status Error',
  SELECT_DEFAULT_SCANNER: '[Scanner] Select Default Scanner',
};

export interface IPayloadAction extends Action {
  payload?: any;
}

export class ApplicationBatchError implements IPayloadAction {
  readonly type = ScannerActions.APPLICATION_BATCH_ERROR;
  constructor(public payload: string) {}
}
export class LoadScanner implements IPayloadAction {
  readonly type = ScannerActions.LOAD_SCANNER;
  constructor(public payload: string) {}
}
export class ScannerLoaded implements IPayloadAction {
  readonly type = ScannerActions.SCANNER_LOADED;
}

export class InitializeScanner implements IPayloadAction {
  readonly type = ScannerActions.INITIALIZE_SCANNER;
  constructor() {}
}

export class ScannerInitialized implements IPayloadAction {
  readonly type = ScannerActions.SCANNER_INITIALIZED;
}

export class GetScannerList implements IPayloadAction {
  readonly type = ScannerActions.GET_SCANNER_LIST;
}

export class ScannerListReceived implements IPayloadAction {
  readonly type = ScannerActions.SCANNER_LIST_RECEIVED;
  constructor(public payload: any) {}
}

export class SelectScanner implements IPayloadAction {
  readonly type = ScannerActions.SELECT_SCANNER;
  constructor(public payload: {index: number, name: string}) {}
}

export class ScannerSelected implements IPayloadAction {
  readonly type = ScannerActions.SCANNER_SELECTED;
  constructor(public payload: IScannerSource) {}
}

export class FormStatusToggle implements IPayloadAction {
  readonly type = ScannerActions.FORM_STATUS_TOGGLE;
}

export class AcquireImages implements IPayloadAction {
  readonly type = ScannerActions.ACQUIRE_IMAGES;
}

export class ImagesAcquired implements IPayloadAction {
  readonly type = ScannerActions.IMAGES_ACQUIRED;
}

export class ExtractImages implements IPayloadAction {
  readonly type = ScannerActions.EXTRACT_IMAGES;
}

export class ImagesExtracted implements IPayloadAction {
  readonly type = ScannerActions.IMAGES_EXTRACTED;
  constructor(public payload: any) {}
}

export class FailedToScan implements IPayloadAction {
  readonly type = ScannerActions.SCAN_FAILED;
  constructor(public payload) {}
}

export class NothingToScan implements IPayloadAction {
  readonly type = ScannerActions.NOTHING_TO_SCAN;
}

export class SendImagesBatch implements IPayloadAction {
  readonly type = ScannerActions.SEND_IMAGES_BATCH;
}

export class SendImagesBatchError implements IPayloadAction {
  readonly type = ScannerActions.SEND_IMAGES_BATCH_ERROR;
  constructor(public payload) {}
}

export class ImageSent implements IPayloadAction {
  readonly type = ScannerActions.IMAGE_SENT;
  constructor(public payload) {}
}

export class ImagesBatchSent implements IPayloadAction {
  readonly type = ScannerActions.IMAGES_BATCH_SENT;
}

export class DestroyScanner implements IPayloadAction {
  readonly type = ScannerActions.DESTROY_SCANNER;
}

export class ScannerDestroyed implements IPayloadAction {
  readonly type = ScannerActions.SCANNER_DESTROYED;
}

export class UpdateScanStatus implements IPayloadAction {
  readonly type = ScannerActions.UPDATE_SCAN_STATUS;
}

export class ScanEntitiesReceived implements IPayloadAction {
  readonly type = ScannerActions.SCANS_ENTITIES_RECEIVED;
  constructor(public payload) {}
}

export class UpdateScanError implements IPayloadAction {
  readonly type = ScannerActions.UPDATE_SCAN_ERROR;
  constructor(public payload) {}
}

export class GetScans implements IPayloadAction {
  readonly type = ScannerActions.GET_SCANS;
  constructor(public payload: IGetScansPayload) {}
}

export class GetScansSuccess implements IPayloadAction {
  readonly type = ScannerActions.GET_SCANS_SUCCESS;
  constructor(public payload) {}
}

export class GetScansError implements IPayloadAction {
  readonly type = ScannerActions.GET_SCANS_ERROR;
  constructor(public payload) {}
}

export class ApiPolicyReceived implements IPayloadAction {
  readonly type = ScannerActions.API_POLICY_RECEIVED;
  constructor(public payload) {}
}

export class FetchApiPolicy implements IPayloadAction {
  readonly type = ScannerActions.FETCH_API_POLICY;
}

export class FetchApiPolicyError implements IPayloadAction {
  readonly type = ScannerActions.FETCH_API_POLICY_ERROR;
  constructor(public payload) {}
}

export class SubmitToScoring implements IPayloadAction {
  readonly type = ScannerActions.SUBMIT_TO_SCORING;
  constructor(public payload) {}
}

export class SubmitToScoringError implements IPayloadAction {
  readonly type = ScannerActions.SUBMIT_TO_SCORING_ERROR;
  constructor(public payload) {}
}

export class SubmitToScoringCompleted implements IPayloadAction {
  readonly type = ScannerActions.SUBMIT_TO_SCORING_COMPLETED;
}

export class ScoringCompleted implements IPayloadAction {
  readonly type = ScannerActions.SCORING_COMPLETED;
}

export class ResetScans implements IPayloadAction {
  readonly type = ScannerActions.RESET_SCANS;
}

export class FetchApiStatus implements IPayloadAction {
  readonly type = ScannerActions.FETCH_API_STATUS;
}

export class FetchApiStatusSuccess implements IPayloadAction {
  readonly type = ScannerActions.FETCH_API_STATUS_SUCCESS;
}

export class FetchApiStatusError implements IPayloadAction {
  readonly type = ScannerActions.FETCH_API_STATUS_ERROR;
}

export class SelectDefaultScanner implements IPayloadAction {
  readonly type = ScannerActions.SELECT_DEFAULT_SCANNER;
}
